export default "<div #expandWrapper class=\"expand-wrapper\" [class.collapsed]=\"!expanded\">\r\n  <ng-content></ng-content>\r\n</div>\r\n";